import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Included(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M19.774 5.367a1 1 0 01-.14 1.407c-2.657 2.173-4.848 4.846-6.383 6.995a44.211 44.211 0 00-1.764 2.665 31.758 31.758 0 00-.572.976l-.027.05-.006.012-.002.002a1 1 0 01-1.48.326l-4-3a1 1 0 011.2-1.6l3.1 2.325.079-.131a46.181 46.181 0 011.845-2.788c1.59-2.226 3.899-5.053 6.743-7.38a1 1 0 011.407.14z",
    clipRule: "evenodd"
  }));
}

export default Included;